export enum InvoiceState {
  Draft = "draft",
  Completed = "completed",
  Sent = "sent",
  Paid = "paid",
}
